import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import { actions } from "app/redux/slice";
import { BoardType, IBoardMenu } from "app/types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getBoardIconIcon } from "../../containers/Home/containers/helpers";
import { selectDraftBoardForm } from "../Settings/redux/selector";
import { useBoardsActions } from "../useBoardsActions";

import { actions as boardsActions } from "app/containers/Features/containers/Boards/components/Settings/redux/slice";
import { useBoardFormChanged } from "../Settings/helper";
interface LotOfBoardProps {
  readonly trigger?: React.ReactNode;
  readonly options: IBoardMenu[];
}

const LotOfBoards: React.FC<LotOfBoardProps> = ({ trigger, options }) => {
  const params = useParams();
  const { boardId } = params;

  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const boardsForm = useSelector(selectDraftBoardForm);
  const { fetchBoardsGroupsJson } = useBoardsActions(params?.project as string);
  const isFormChanged = useBoardFormChanged();
  const handleNav = (data: IBoardMenu) => {
    if (isFormChanged) {
      dispatch(boardsActions.toggleBoardDraftFormModal(true));
      return;
    }
    fetchBoardsGroupsJson(
      data?.boardId,
      boardsForm.groupBy,
      boardsForm.subGroupBy,
      () => {
        dispatch(
          actions.updateBoardOrderState({
            selectedId: boardId as string,
            clickedId: data.boardId,
          }),
        );
        dispatch(actions.doUpdateBoardOrder());
        let newPath = "";
        if (data?.Type === BoardType.Backlog) {
          newPath = `/app/${params.project}/${params.team}/boards/${data.boardId}/backlog`;
        } else {
          newPath = `/app/${params.project}/${params.team}/boards/${data.boardId}/${data?.viewType}/board`;
        }
        navigate(newPath);
      },
    );
  };
  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
        <PopoverContent
          align="start"
          className={`!px-0 !py-0 pb-2 bg-white border border-[#E9ECF2] cursor-pointer max-h-[380px] overflow-scroll max-w-[250px]`}
        >
          <div className="flex items-center gap-2 p-4 text-[#253858] text-base font-semibold border-b border-[#E9ECF2] sticky top-0 bg-white">
            Boards
          </div>
          {options?.map((option) => {
            return (
              <div
                key={option?.boardId}
                className="flex w-full items-center gap-3 text-sm font-normal text-black text-[#79808A] cursor-pointer hover:bg-[#F4F5F7] p-4 "
                onClick={() => {
                  handleNav(option);
                }}
              >
                {getBoardIconIcon(option)}
                <span className="truncate">{option?.name}</span>
              </div>
            );
          })}
        </PopoverContent>
      </Popover>
    </>
  );
};

export default LotOfBoards;
